/**
 * Project-number format helpers — thin aliases over the shared entity-number engine.
 * Default preserves historical `ANF-YY-#####` allocation.
 */
import {
  ENTITY_NUMBER_FORMAT_MAX_LEN,
  ENTITY_NUMBER_SEQ_DIGITS_MAX,
  ENTITY_NUMBER_SEQ_DIGITS_MIN,
  buildEntityNumberFormat,
  counterYearForFormat,
  entityNumberFormatUsesYear,
  isUniqueViolation,
  normalizeEntityNumberFormat,
  normalizeManualEntityNumber,
  parseEntityNumberFormatParts,
  parseSeqDigits,
  renderEntityNumber,
  type EntityNumberFormatParts,
  type EntityNumberFormatValidation,
  type EntityNumberYearMode,
  type ManualEntityNumberValidation,
} from './entityNumberFormat';

/** Default template — preserves historical `ANF-YY-#####` allocation. */
export const DEFAULT_PROJECT_NUMBER_FORMAT = 'ANF-{YY}-{SEQ:5}';

export const PROJECT_NUMBER_FORMAT_MAX_LEN = ENTITY_NUMBER_FORMAT_MAX_LEN;
export const PROJECT_NUMBER_SEQ_DIGITS_MIN = ENTITY_NUMBER_SEQ_DIGITS_MIN;
export const PROJECT_NUMBER_SEQ_DIGITS_MAX = ENTITY_NUMBER_SEQ_DIGITS_MAX;

export type ProjectNumberFormatValidation = EntityNumberFormatValidation;
export type ManualProjectNumberValidation = ManualEntityNumberValidation;
export type ProjectNumberYearMode = EntityNumberYearMode;
export type ProjectNumberFormatParts = EntityNumberFormatParts;

export function normalizeProjectNumberFormat(raw: unknown): ProjectNumberFormatValidation {
  return normalizeEntityNumberFormat(raw);
}

export function projectNumberFormatUsesYear(format: string): boolean {
  return entityNumberFormatUsesYear(format);
}

export { parseSeqDigits, counterYearForFormat, isUniqueViolation };

export function buildProjectNumberFormat(parts: ProjectNumberFormatParts): string {
  return buildEntityNumberFormat(parts);
}

export function parseProjectNumberFormatParts(format: string): ProjectNumberFormatParts {
  return parseEntityNumberFormatParts(format, DEFAULT_PROJECT_NUMBER_FORMAT);
}

export function renderProjectNumber(
  format: string,
  seq: number,
  calendarYear: number = new Date().getFullYear(),
): string {
  return renderEntityNumber(format, seq, calendarYear);
}

export function normalizeManualProjectNumber(raw: unknown): ManualProjectNumberValidation {
  return normalizeManualEntityNumber(raw, 'Projektnummer');
}
